/* ============================================================
   LGM — subtle scroll-reveal
   A quiet fade + rise as each section enters the viewport.
   Design intent: presence through restraint — a soft, slow ease,
   never a bounce or a slide. One reveal per section.

   Robustness contract:
   - The hidden initial state in lgm-custom.css is gated on the
     `.lgm-anim` class, which ONLY this script adds. If the script
     never runs (JS off, error, old browser) content stays visible.
   - We bail entirely under prefers-reduced-motion, so those users
     never see a hidden state either.
   - Above-the-fold content is revealed synchronously (same tick it
     is hidden) so it never visibly flashes; only below-the-fold
     sections animate on scroll.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var main = document.getElementById('main');
  if (!main) return;

  var root = document.documentElement;
  root.classList.add('lgm-anim');

  var sections = main.querySelectorAll(':scope > .shopify-section, :scope > section');
  if (!sections.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  var viewportHeight = window.innerHeight || root.clientHeight;
  var immediateZone = viewportHeight * 0.85; /* treat as above-the-fold */

  sections.forEach(function (section) {
    var target = section.firstElementChild;
    if (!target) return;

    target.setAttribute('data-lgm-reveal', '');

    /* Reveal what's already in view without animating (avoids a flash),
       observe everything below the fold. */
    if (target.getBoundingClientRect().top < immediateZone) {
      target.classList.add('is-revealed');
    } else {
      observer.observe(target);
    }
  });
})();

/* ============================================================
   LGM — close the mobile menu drawer on in-page anchor clicks
   The header drawer (#sidebar-menu) closes on its own when a link
   navigates to another page. But an in-page anchor on the CURRENT
   page (e.g. "Brand Story" → /#brand-story while already on the
   homepage) doesn't navigate, so the drawer would stay open over
   the section it just scrolled to. We detect that case, close the
   drawer via its own hide(), then scroll to the target once it has
   settled (avoids the drawer's scroll-lock swallowing the jump).
   scroll-padding-top (lgm-custom.css) keeps it clear of the header.
   Falls back to native behaviour if the drawer/target isn't found.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var link = event.target.closest('#sidebar-menu a[href*="#"]');
    if (!link) return;

    var target;
    try {
      target = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }

    /* Only handle anchors that scroll within the page we're already on. */
    if (!target.hash) return;
    if (target.pathname !== window.location.pathname) return;
    if (target.search !== window.location.search) return;

    var drawer = document.getElementById('sidebar-menu');
    if (!drawer || typeof drawer.hide !== 'function') return; /* let the browser handle it */

    var destination = document.getElementById(decodeURIComponent(target.hash.slice(1)));

    event.preventDefault();

    Promise.resolve(drawer.hide()).then(function () {
      if (destination) {
        destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (window.history && history.replaceState) {
        history.replaceState(null, '', target.hash);
      }
    });
  });
})();
